var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadOcr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 18.75C2.51953 18.75 0 16.2305 0 13.125C0 10.6719 1.57031 8.58594 3.75781 7.81641C3.75391 7.71094 3.75 7.60547 3.75 7.5C3.75 4.04688 6.54688 1.25 10 1.25C12.3164 1.25 14.3359 2.50781 15.418 4.38281C16.0117 3.98438 16.7305 3.75 17.5 3.75C19.5703 3.75 21.25 5.42969 21.25 7.5C21.25 7.97656 21.1602 8.42969 21 8.85156C23.2812 9.3125 25 11.332 25 13.75C25 16.5117 22.7617 18.75 20 18.75H5.625ZM8.71094 10.2734C8.34375 10.6406 8.34375 11.2344 8.71094 11.5977C9.07812 11.9609 9.67188 11.9648 10.0352 11.5977L11.5586 10.0742V15.3125C11.5586 15.832 11.9766 16.25 12.4961 16.25C13.0156 16.25 13.4336 15.832 13.4336 15.3125V10.0742L14.957 11.5977C15.3242 11.9648 15.918 11.9648 16.2812 11.5977C16.6445 11.2305 16.6484 10.6367 16.2812 10.2734L13.1562 7.14844C12.7891 6.78125 12.1953 6.78125 11.832 7.14844L8.70703 10.2734H8.71094Z",
    fill: "#94A3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadOcr);
export default __webpack_public_path__ + "static/media/upload_ocr.a47c9a22ad21601f728ae4150965755d.svg";
export { ForwardRef as ReactComponent };